import {
  AssignedUserType,
  ContactType,
  MerchantAccountStatus,
} from '../../core/constants';
import { StreetAddress } from '../streetAddress/streetAddress';
import { MerchantProcessor } from './merchantProcessor';
import { AssignedUser } from '../users/assignedUser';
import { CampfireMerchant } from '../integrations/campfireMerchant';

// TODO (jacob): This should be be cleaned up
export class Merchant {
  id: string;
  accountId: string;
  myMerchant: boolean;
  accountStatus: MerchantAccountStatus;
  legalName: string;
  streetAddress: Partial<StreetAddress> = StreetAddress.createEmpty();
  billingAddress: Partial<StreetAddress> = StreetAddress.createEmpty();
  billingName: string;
  billingAccountNum: string;
  billingRoutingNum: string;
  billingAccountHolderType: string;
  billingAccountType: string;
  EIN: string | undefined;
  MID: string | undefined;
  achMid: string | undefined;
  MCC: string | undefined;
  MCCDescription: string | undefined;
  processors: MerchantProcessor[] = [];
  DBA: string;
  phone: string | undefined;
  fax: string | undefined;
  website: string | undefined;
  timezone: string | undefined;
  commodityCode: string | undefined;
  integrationEnabled: boolean = false;
  clientId: string | undefined;
  clientKey: string | undefined;
  sandboxClientId: string | undefined;
  sandboxClientKey: string | undefined;
  sandboxEnabled: boolean = false;
  tokenVaultName: string | undefined;
  gateway: string | undefined;
  processor: string | string[] | undefined;
  processorType: string | string[] | undefined;
  // TODO: remove this
  //contacts: MerchantContact[] = [];
  users: AssignedUser[] = [];

  //assignedUsers: MerchantAssignedUser[] = [];
  depositAccount: string | undefined;
  withdrawalAccount: string | undefined;
  apiEnabled: boolean | undefined;
  apiKey: string | undefined;
  apiPassphrase: string | undefined;
  createdOn: Date | undefined;
  //groupId: string | undefined;
  groupName: string | undefined;
  //brandId: string | undefined;
  brandName: string | undefined;
  posSoftware: string | undefined;
  highRisk: boolean = false;
  customIntegration: boolean = false;
  hasPhysicalTerminal: boolean = false;
  outsidePartner: boolean = false;
  businessType: string | undefined;
  businessDescription: string | undefined;
  integrations: string[] | undefined;
  campfireMerchant: CampfireMerchant | undefined;
  

  constructor(m: Partial<Merchant>) {
    if (m.id == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} id cannot be null`,
      );
    if (m.accountId == null) {
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} account id cannot be null`,
      );
    }
    if (m.legalName == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} name cannot be null`,
      );
    //if (m.name == null)
    //    throw new Error(`Invalid merchant in constructor: ${JSON.stringify(m)} name cannot be null`);
    if (m.streetAddress == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} streetAddress cannot be null`,
      );
    if (m.billingAddress == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} billingAddress cannot be null`,
      );
    if (m.billingName == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} billingName cannot be null`,
      );
    if (m.billingAccountNum == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} billingAccountNum cannot be null`,
      );
    if (m.billingRoutingNum == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} billingRoutingNum cannot be null`,
      );
    if (m.billingAccountHolderType == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} billingAccountHolderType cannot be null`,
      );
    if (m.billingAccountType == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} billingAccountType cannot be null`,
      );
    if (m.DBA == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} DBA cannot be null`,
      );
    if (m.accountStatus == null)
      throw new Error(
        `Invalid merchant in constructor: ${JSON.stringify(m)} account status cannot be null`,
      );
    // if (m.contacts == null) {
    //     throw new Error(`Invalid merchant in constructor: ${JSON.stringify(m)} contacts cannot be null`);
    // }

    if (m.myMerchant != undefined) this.myMerchant = m.myMerchant;
    else this.myMerchant = false;

    /*
     * Required
     */

    this.id = m.id;
    this.accountId = m.accountId;
    this.legalName = m.legalName;
    this.streetAddress = m.streetAddress;
    this.billingAddress = m.billingAddress;
    this.billingName = m.billingName;
    this.billingAccountNum = m.billingAccountNum;
    this.billingRoutingNum = m.billingRoutingNum;
    this.billingAccountHolderType = m.billingAccountHolderType;
    this.billingAccountType = m.billingAccountType;
    this.DBA = m.DBA;
    this.timezone = m.timezone;
    this.accountStatus = m.accountStatus;
    this.phone = m.phone;
    this.fax = m.fax;
    this.MCC = m.MCC;
    this.MCCDescription = m.MCCDescription;
    this.commodityCode = m.commodityCode;
    this.businessType = m.businessType;
    this.businessDescription = m.businessDescription;
    this.integrationEnabled = m.integrationEnabled ?? false;
    this.clientId = m.clientId;
    this.clientKey = m.clientKey;
    this.sandboxClientId = m.sandboxClientId;
    this.sandboxClientKey = m.sandboxClientKey;
    this.sandboxEnabled = m.sandboxEnabled ?? false;
    this.tokenVaultName = m.tokenVaultName;
    this.gateway = m.gateway;
    this.processor = m.processor;
    this.processorType = m.processorType;
    /*
     * Optional
     */
    this.brandName = m.brandName;
    this.groupName = m.groupName;

    if (m.processors != null) {
      this.processors = m.processors;
    } else {
      this.processors = [];
    }

    // if (m.contacts) {
    //     this.contacts = m.contacts;
    // } else {
    //     this.contacts = [];
    // }

    if (m.users) {
      this.users = m.users;
    }

    this.apiEnabled = m.apiEnabled;
    this.apiKey = m.apiKey;
    this.apiPassphrase = m.apiPassphrase;

    this.EIN = m.EIN;
    this.MID = m.MID;
    this.website = m.website;
    this.timezone = m.timezone;
    this.depositAccount = m.depositAccount;
    this.withdrawalAccount = m.withdrawalAccount;
    this.posSoftware = m.posSoftware;
    this.highRisk = m.highRisk ?? false;
    this.customIntegration = m.customIntegration ?? false;
    this.hasPhysicalTerminal = m.hasPhysicalTerminal ?? false;
    this.outsidePartner = m.outsidePartner ?? false;
    this.businessType = m.businessType;
    this.businessDescription = m.businessDescription;
    this.integrations = m.integrations;
    this.campfireMerchant = m.campfireMerchant;

    if (m.createdOn) {
      this.createdOn = new Date(m.createdOn);
    }
  }

  static createEmpty(): Merchant {
    return new Merchant({
      id: '',
      accountId: '',
      legalName: '',
      streetAddress: StreetAddress.createEmpty(),
      billingAddress: StreetAddress.createEmpty(),
      billingName: '',
      billingAccountNum: '',
      billingRoutingNum: '',
      billingAccountHolderType: '',
      billingAccountType: '',
      DBA: '',
      timezone: '',
      MID: '',
      achMid: '',
      commodityCode: '',
      accountStatus: MerchantAccountStatus.Disabled,
      apiEnabled: false,
      apiKey: '',
      apiPassphrase: '',
      website: '',
      phone: '',
      fax: '',
      posSoftware: '',
      highRisk: false,
      customIntegration: false,
      hasPhysicalTerminal: false,
      outsidePartner: false,
      users: [],
      businessType: '',
      businessDescription: '',
      integrationEnabled: false,
      clientId: '',
      clientKey: '',
      sandboxClientId: '',
      sandboxClientKey: '',
      sandboxEnabled: false,
      tokenVaultName: '',
      gateway: '',
      processor: [],
      processorType: [],
      integrations: [],
      campfireMerchant: undefined,
    });
  }

  getContactByType(type: ContactType): AssignedUser | null {
    for (let i = 0; i < this.users.length; i++) {
      for (let j = 0; j < this.users[i].contactTypes.length; j++) {
        if (this.users[i].contactTypes[j] == type) {
          return this.users[i];
        }
      }
    }
    return null;
  }

  public get primaryContact(): AssignedUser | undefined {
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[i].contactTypes.includes(ContactType.Primary)) {
        return this.users[i];
      }
    }
    return undefined;
  }

  public get salesContacts(): AssignedUser[] {
    return this.users.filter((c) =>
      c.contactTypes.includes(AssignedUserType.Sales),
    );
  }

  public get successContacts(): AssignedUser[] {
    return this.users.filter((c) =>
      c.contactTypes.includes(AssignedUserType.Success),
    );
  }

  public get partnerContacts(): AssignedUser[] {
    return this.users.filter((c) =>
      c.contactTypes.includes(AssignedUserType.Partner),
    );
  }

  public get depositAccountMasked(): string {
    if (this.depositAccount) {
      //return this.maskAccount(this.depositAccount);
      return (
        'XXX-XX-' +
        this.depositAccount.substring(
          this.depositAccount.length - 4,
          this.depositAccount.length,
        )
      );
    }
    return '';
  }

  public get withdrawalAccountMasked(): string {
    if (this.withdrawalAccount) {
      let acct = this.withdrawalAccount;
      //return this.maskAccount(this.withdrawalAccountMasked);
      return (
        'XXX-XX-' +
        this.withdrawalAccount.substring(
          this.withdrawalAccount.length - 4,
          this.withdrawalAccount.length,
        )
      );
    }
    return '';
  }

  // TODO (jacob): This should probably be done server side?
  //private maskAccount(account: string): string {
  //    return "XXX-XX-" + account.substring(account.length-4, account.length);
  //}
}
